import React from "react";
import { INLINES, BLOCKS } from "@contentful/rich-text-types";
import { WMKLink } from "wmk-lib";
import Theme from "../vars/ThemeOptions";
import get from "lodash/get";

const options = {
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: (node) => {
      //console.log('ASSET:',node);
      const fields = get(node, `data.target.fields`);
      const imgUrl = get(fields, `file["en-US"].url`, false);
      const imgAlt = get(fields, `title["en-US"]`, "");
      return imgUrl ? (
        <div className="embedded-image-wrap">
          <img
            className="embedded-image"
            width={700}
            height={400}
            src={imgUrl + "?w=700&h=400&q=75&fit=pad"}
            alt={imgAlt}
          />
        </div>
      ) : (
        <em>Error loading image.</em>
      );
    },
    [BLOCKS.EMBEDDED_ENTRY]: (node) => {
      const contentType = get(node, `data.target.sys.contentType.sys.id`);
      const cta = get(node, `data.target.fields`);
      const hubspotCta = get(cta, `embedCode["en-US"]`, null);

      let JSX = null;
      switch (contentType) {
        case "hubspotCta":
          JSX = hubspotCta && (
            <div
              className={"hubspot-cta"}
              dangerouslySetInnerHTML={{ __html: hubspotCta }}
            />
          );
          break;

        case "youTubeVideo":
          const youTubeVideo = get(cta, `url["en-US"]`);
          const source =
            youTubeVideo &&
            (youTubeVideo.indexOf("youtu.be") >= 0
              ? youTubeVideo.replace("youtu.be", "www.youtube.com/embed")
              : youTubeVideo.replace("watch?v=", "embed/"));
          JSX = source && (
            <div className="embedded-youtube-wrap">
              <iframe
                width="560"
                height="315"
                src={source}
                frameBorder="0"
                allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title={cta.title["en-US"]}
              />
            </div>
          );
          break;
        default:
          JSX = <em>Error loading asset.</em>;
      }
      //console.log(cta)
      return JSX;
    },
    [INLINES.EMBEDDED_ENTRY]: (node) => {
      const { sys, fields } = node.data.target;
      const contentType = get(sys, `contentType.sys.id`);
      const slug = get(fields, `slug["en-US"]`);
      const title = get(fields, `title["en-US"]`);
      const entryTypes = {
        wmkBlogs: WMKLink,
      };
      const JSX = entryTypes[contentType];
      return JSX ? (
        <JSX to={`/blog/${slug}`}>{title}</JSX>
      ) : (
        <em>{contentType} is not configured</em>
      );
    },
    [INLINES.ENTRY_HYPERLINK]: (node, children) => {
      // If you are using contenful.js sdk, the referenced entry is resolved
      // automatically and is available at `node.data.target`.
      //const referencedEntry = getEntryWithId(node.data.target.sys.id);
      //console.log(node.data.target,children)
      const theEntry = get(node, `data.target.fields`);
      const contentType = get(node, `data.target.sys.contentType.sys.id`);
      let path = "";
      //console.log(theEntry)
      if (contentType) {
        switch (contentType) {
          case "wmkBlogs":
            path = Theme.paths.blog;
            break;
          case "wmkServices":
            path = Theme.paths.services;
            break;
          case "wmkPages":
            path = Theme.paths.pages;
            break;
          default:
          //nothing
        }
      }
      //console.log(node.data.target.sys,path)
      return theEntry ? (
        <WMKLink to={`${path}${theEntry.slug["en-US"]}`}>{children}</WMKLink>
      ) : (
        <em className="hyperlink-error">{children}</em>
      );
    },
  },
};

export default options;
